import Vue from "vue";
import App from "@/App";
import "@/registerServiceWorker";
import router from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import appSettings from "@/config";
// services
import { buildApi } from "@/services/cityCenter/api/apiCityCenter";
// store
import { INITIALIZE_STATES } from "@/store/solution/mutation-types";
// keycloak
import Keycloak from "keycloak-js";
import apiCityCenter from "./services/cityCenter/api/apiCityCenter";
import { getPayloadForPermissions } from "@/services/cityCenter/login/loginService";
Vue.config.productionTip = false;

/**
 * URL of Runtime/Production Settings
 * @type {string}
 */
const urlRuntimeSettings = "/city-center/runtimeSettings.json"; // this is to ensure that everytime when page is refreshed then runtimeSettings.json file should be fetched from correct URL
//
// if (!isDevelopment) {
fetch(urlRuntimeSettings)
  .then(response => {
    response
      .json()
      .then(runtimeSettings => {
        for (let key in runtimeSettings) {
          appSettings[key] = runtimeSettings[key];
        }
        CompleteInitialization();
      })
      .catch(e => {
        console.error("Parse Settings Failed", e);
        CompleteInitialization();
      });
  })
  .catch(e => {
    console.error("Load Settings Failed", e);
    CompleteInitialization();
  });

function CompleteInitialization() {
  buildApi();
  const keycloak = keycloakObject();
  const options = keycloakOptions();
  keycloak
    .init({ onLoad: options?.onLoad })
    .then(async auth => {
      if (auth) {
        await store.dispatch("user/initKeycloak", keycloak);
        await store.dispatch("user/logIn");
        apiCityCenter.updateAuthorization(keycloak);
        const payload = getPayloadForPermissions();
        await store
          .dispatch("user/setUserPermissions", payload)
          .catch(() => console.error("Failed to load permissions"));
      } else {
        console.info(`Not Authenticated`);
        window.location.reload();
      }

      new Vue({
        router,
        store,
        beforeCreate() {
          this.$store.commit(`solution/${INITIALIZE_STATES}`);
        },
        vuetify,
        render: h => h(App)
      }).$mount("#app");
      const minValidity = 70;
      const timeout = 60000;
      setInterval(() => {
        keycloak
          .updateToken(minValidity)
          .then(refreshed => {
            if (refreshed) {
              apiCityCenter.updateAuthorization(keycloak);
            } else {
              let secondsToExpire = Math.round(
                keycloak.tokenParsed.exp +
                  keycloak.timeSkew -
                  new Date().getTime() / 1000
              ).toString();
              console.warn(
                `Token not refreshed, valid for ${secondsToExpire} seconds`
              );
            }
          })
          .catch(() => {
            console.error("Failed to refresh token");
            keycloak.logout();
          });
      }, timeout);
    })
    .catch(e => {
      console.log(e);
      console.error("Authentication Failed");
    });
}

function keycloakOptions() {
  return {
    url: appSettings["identityProviderUrl"],
    realm: appSettings["identityProviderRealm"],
    clientId: appSettings["identityProviderClientId"],
    onLoad: "login-required"
  };
}

function keycloakObject() {
  return new Keycloak(keycloakOptions());
}
export { keycloakObject };
